'use client';

import { getCookieValue, removeCookie } from '@/utils/cookies/client';
import { getConfig } from '@/utils/config/config';
import { type OsanoConsent } from '@/types/osano-consent';
import { OSANO_COOKIES_BY_CLASSIFICATION } from './osano-cookies';

const OSANO_CONSENT_COOKIE_NAME = 'osano_consentmanager';

const hasUserSavedConsent = (): boolean => {
    if (typeof document === 'undefined') {
        return false;
    }
    return getCookieValue(OSANO_CONSENT_COOKIE_NAME).length > 0;
};

export const osanoShowDialog = (): void => {
    if (typeof window !== 'undefined') {
        window.Osano?.cm?.showDrawer();
    }
};

const removeServerSideCookies = (consent: OsanoConsent): void => {
    const config = getConfig();
    const domain = config?.domain;
    const rootDomain = config?.rootDomain;

    OSANO_COOKIES_BY_CLASSIFICATION.forEach(({ classification, name }) => {
        const approval = consent[classification];
        if (approval === 'DENY') {
            removeCookie(name, '/', domain); // there is no way of determining on what domain the cookie has been set, so we need to try them all
            removeCookie(name, '/', rootDomain);
            if (typeof window !== 'undefined') {
                removeCookie(name, '/', window.location.host);
            }
        }
    });
};

export const removeServerSideCookiesBasedOnConsent = (): void => {
    if (typeof window === 'undefined' || !window.Osano?.cm) {
        return;
    }

    const consent: OsanoConsent = window.Osano.cm.getConsent();
    removeServerSideCookies(consent);
};

const OSANO_RETRY_MS = 50;
const OSANO_MAX_RETRIES = 120; // ~6s at 50ms interval

export const initializeCookieListener = (retriesRemaining: number = OSANO_MAX_RETRIES): void => {
    if (typeof window === 'undefined') {
        return;
    }

    if (!window.Osano?.cm) {
        if (retriesRemaining > 0) {
            setTimeout(() => initializeCookieListener(retriesRemaining - 1), OSANO_RETRY_MS);
        }
        return;
    }

    removeServerSideCookiesBasedOnConsent();

    if (hasUserSavedConsent()) {
        window.Osano.cm.hideWidget();
    }
    window.Osano.cm.addEventListener('osano-cm-consent-saved', removeServerSideCookies);
    window.Osano.cm.addEventListener('osano-cm-consent-saved', () => {
        window.Osano?.cm?.hideWidget();
    });
};
